(function (host) {
  'use strict';
  function quantity(value, min, max) {
    var n = Number(value);
    return Number.isFinite(n) ? Math.max(min, Math.min(max, Math.trunc(n))) : min;
  }
  function scopedQuantity(scope, count, mainQty, kitSize, blockSize) {
    if (scope === 'per_order') return 1;
    if (scope === 'per_kit') return mainQty;
    if (scope === 'per_block') return mainQty * quantity(blockSize, 1, 999);
    if (scope === 'per_device' || scope === 'per_seat') return mainQty * quantity(kitSize, 1, 999);
    return quantity(count, 0, 99);
  }
  function priceParts(line) {
    var cents = line.priceCents * line.quantity;
    var fee = Number(line.creditCardFee) || 0;
    var tariff = Number(line.tariffRate) || 0;
    if (!Number.isFinite(fee) || fee < 0) fee = 0;
    if (!Number.isFinite(tariff) || tariff < 0) tariff = 0;
    var beforeFee = fee > 0 ? Math.round(cents / (1 + fee)) : cents;
    var base = tariff > 0 ? Math.round(beforeFee / (1 + tariff)) : beforeFee;
    var explicitBase = Number(line.tariffBaseCents);
    if (Number.isFinite(explicitBase) && explicitBase > 0 && explicitBase * line.quantity <= beforeFee) base = Math.round(explicitBase * line.quantity);
    return {base:base,tariff:beforeFee-base,cardFee:cents-beforeFee,total:cents};
  }
  function assess(main, lines, mainAgreement, pending) {
    var catalog = main.mode === 'catalog_only';
    var quoteOnly = main.mode === 'quote' || lines.some(function (line) { return line.mode === 'quote'; });
    var unavailable = lines.some(function (line) { return line.mode === 'catalog_only' || !line.available; });
    var termsMissing = Boolean(mainAgreement && !mainAgreement.accepted) || lines.some(function (line) { return line.agreement && !line.agreement.accepted; });
    return {
      catalog: catalog,
      quoteOnly: quoteOnly,
      showPrices: !catalog && !quoteOnly,
      canCart: !catalog && !quoteOnly && !unavailable && !termsMissing && lines.length > 0 && !pending,
      canQuote: !catalog && lines.length > 0 && !pending,
      reason: catalog ? 'catalog_note' : !lines.length ? 'empty_configuration' : quoteOnly ? 'quote_required' : unavailable ? 'sold_out' : termsMissing ? 'accept_required' : '',
      total: lines.reduce(function (sum, line) { return sum + line.priceCents * line.quantity; }, 0)
    };
  }
  function agreementProperties(agreement, now, prefix) {
    if (!agreement || !agreement.accepted) return {};
    var out = {};
    out[prefix + 'required'] = 'true';
    out[prefix + 'terms_html'] = agreement.html;
    out[prefix + 'terms_text'] = agreement.text;
    out[prefix + 'accepted_at'] = now;
    out[prefix + 'product_title'] = agreement.title;
    out[prefix + 'product_id'] = agreement.productId;
    out[prefix + 'product_handle'] = agreement.handle;
    return out;
  }
  function cartItems(main, lines, mainAgreement, group, now) {
    var result = assess(main, lines, mainAgreement, false);
    if (!result.canCart) throw new Error(result.reason || 'cart_error');
    return lines.map(function (line) {
      var properties = Object.assign({_configuration: group}, agreementProperties(line.agreement, now, '_agreement_'));
      if (mainAgreement && mainAgreement.productId !== line.productId) Object.assign(properties, agreementProperties(mainAgreement, now, '_kit_agreement_'));
      return {id: String(line.id), quantity: quantity(line.quantity, 1, 99999), properties: properties};
    });
  }
  function quoteDetails(main, lines, qty, custom) {
    return {
      id: String(main.id),
      sku: main.sku || '',
      variant: main.title || '',
      quantity: custom ? 1 : qty,
      addons: lines.filter(function (line) { return custom || String(line.id) !== String(main.id); }).map(function (line) { return line.title + ' · SKU ' + (line.sku || '—') + ' × ' + line.quantity; }).join('; ')
    };
  }
  var api = {quantity: quantity, scopedQuantity: scopedQuantity, priceParts: priceParts, assess: assess, cartItems: cartItems, quoteDetails: quoteDetails};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else host.KnoxHardwarePurchase = api;
})(typeof window !== 'undefined' ? window : this);

